export default __webpack_public_path__ + "media/images/logo-civil-nuclear-constabulary-cd28b257572de07eb935460519aa07e5.svg";